// Reviews date ranges, apart from the query hooks so the route's `validateSearch` stays out of the API client bundle.
export type ReviewsRange = '30d' | '90d';
export const REVIEWS_RANGES: readonly ReviewsRange[] = ['30d', '90d'];
export const DEFAULT_REVIEWS_RANGE: ReviewsRange = '30d';
